import { Playground } from 'docz';
import DemoBlock from "../../../../../src/components/DemoBlock/DemoBlock.tsx";
import Button from "../../../../../src/components/Button/button.tsx";
import * as React from 'react';
export default {
  Playground,
  DemoBlock,
  Button,
  React
};